import { useEffect, useState } from "react";
import { Token, URL_API } from "../../utils/Constant";
import axios from "axios";
import { toast } from "react-toastify";

interface UserInterface {
    [key: string]: any;
}

const useUsersListe = (refresh: boolean): UserInterface[] => {
    const [users, setUsers] = useState<UserInterface[]>([]);

    useEffect(() => {
        const fetchUsers = async () => {
            axios.get(`${URL_API}/admin/user`, {
                headers: {
                    Authorization: `Bearer ${Token}`
                }
            }).then(response => {

                if (response.status == 200) {
                    setUsers(response.data.users);
                }

            }).catch(error => {
                if (error.status === 400) {
                    toast.info(error.data.message);
                }

                if (error.status === 500) {
                    toast.warning(error.data.message);
                }
            })
        };

        fetchUsers();
    }, [refresh]);
    return users;
};

export default useUsersListe;

export const deleteUsers = async ({ id }: { id: number }, onSuccess: () => void) => {

    axios.get(`${URL_API}/admin/destroy/${id}`, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.status === 200) {
            toast.warning(response.data.message)
            onSuccess();
        }

    }).catch(error => {
        if (error.status === 405) {
            toast.info(error.response.data.message)
        }
    })

}

export const changeStatus = ({ id }: { id: number }, onSuccess: () => void) => {
    axios.get(`${URL_API}/admin/changeStatus/${id}`, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.status === 200) {
            toast.warning(response.data.message)
            onSuccess();
        }

    }).catch(error => {
        if (error.status === 405) {
            toast.info(error.response.data.message)
        }
    })
}

export const resetPassword = ({ id }: { id: number }, onSuccess: () => void) => {
    axios.get(`${URL_API}/admin/reser-password/${id}`, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.status === 200) {
            toast.warning(response.data.message)
            onSuccess();
        }

    }).catch(error => {
        if (error.status === 405) {
            toast.info(error.response.data.message)
        }
    })

}
